import { useSelectedQuote } from '../../../modules/moves'
import { QuoteConstraint, useGetQuoteConstraints } from '../../../modules/quotes'
import { useGetConstraintDescription } from '../../QuoteComponent/Constraints/useGetConstraintDescription'

export const useConstraintsWarnings = () => {
  const selectedQuote = useSelectedQuote()

  const getConstraints = useGetQuoteConstraints()
  const getConstraintDescription = useGetConstraintDescription()
  const constraints = selectedQuote ? getConstraints(selectedQuote) : []

  const warnings: Partial<Record<QuoteConstraint, React.ReactNode>> = {}

  constraints.forEach(constraint => {
    if ([
      QuoteConstraint.unavailableDate,
      QuoteConstraint.notEnoughTrucks,
      QuoteConstraint.additionalServicesNotOffered,
      QuoteConstraint.specialItemsNotSupported,
    ].includes(constraint)) {
      warnings[constraint] = getConstraintDescription(constraint)
    }
  })

  return warnings
}
